// context/LabContext.jsx
import React, { createContext, useContext, useState } from "react";
import { fetchLabRequests } from "../utils/patients/fetchlabrequests";
import { fetchLabRequestsAlt } from "../utils/patients/fetchLabrequestAlt";
import { fetchGroupedTest } from "../utils/patients/fetchGroupedTest";
import { QueryLabRequest } from "../utils/patients/querryLabTest";
import { fetchAlltTest } from "../utils/patients/fetchAllTest";
import { sendLabRequest } from "../utils/patients/createLabRequest";
import { fetchPurchasedDrugs } from "../utils/patients/fetchPurchasedDrugs";
import useProfileStore from "../store/patient/profileStore";

const LabContext = createContext();

export const LabProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [requests, setRequests] = useState([]);
  const [groupTest, setGroupedTest] = useState([]);
  const [labs, setLabs] = useState([]);
  const [purchasedDrugs, setPurchasedDrugs] = useState([]);

  const { profile } = useProfileStore();

  const redirectToLogin = (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      localStorage.removeItem("tokenV2");
      localStorage.removeItem("userId");
      window.location.href = "/pages/signin2";
    }
  };

  const handleFechLabRequests = async () => {
    if (!profile?.id) return;
    setLoading(true);
    try {
      const res = await fetchLabRequests(profile.id);
      setRequests(res?.data?.result);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFechLabRequestsAlt = async () => {
    if (!profile?.id) return;
    setLoading(true);
    try {
      const res = await fetchLabRequestsAlt(profile.id);
      setRequests(res?.data?.result);
    } catch (err) {
      redirectToLogin(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFechGroupedTest = async () => {
    if (!profile?.id) return;
    setLoading(true);
    try {
      const res = await fetchGroupedTest(profile.id);
      setGroupedTest(res?.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFechAllTest = async () => {
    if (!profile?.id) return;
    setLoading(true);
    try {
      const res = await fetchAlltTest(profile.id);
      setLabs(res?.data);
    } catch (err) {
      redirectToLogin(err);
    } finally {
      setLoading(false);
    }
  };

  const handleQueryTest = async (data, prof) => {
    setLoading(true);
    try {
      const res = await QueryLabRequest(data, prof);
      setLabs(res?.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitRequest = async (id, request_type, payload, note) => {
    setLoading(true);
    try {
      const response = await sendLabRequest(id, request_type, payload, note);
      return response;
    } catch (err) {
      console.log(err);
      redirectToLogin(err);
    } finally {
      setLoading(false);
    }
  };

  const handleFetchPurchasedDrugs = async (request_type) => {
    setLoading(true);
    try {
      const res = await fetchPurchasedDrugs(profile?.id, request_type);
      setPurchasedDrugs(res?.data?.result);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LabContext.Provider
      value={{
        loading,
        requests,
        groupTest,
        labs,
        purchasedDrugs,
        handleFechLabRequests,
        handleFechLabRequestsAlt,
        handleFechGroupedTest,
        handleFechAllTest,
        handleQueryTest,
        handleSubmitRequest,
        handleFetchPurchasedDrugs,
      }}
    >
      {children}
    </LabContext.Provider>
  );
};

export const useLab = () => {
  const context = useContext(LabContext);
  if (!context) {
    throw new Error("useLab must be used within a LabProvider");
  }
  return context;
};
